import { render, staticRenderFns } from "./TypeMenu.vue?vue&type=template&id=129d4bc5&scoped=true"
import script from "./TypeMenu.vue?vue&type=script&lang=js"
export * from "./TypeMenu.vue?vue&type=script&lang=js"
import style0 from "./TypeMenu.vue?vue&type=style&index=0&id=129d4bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d4bc5",
  null
  
)

export default component.exports